import { ArtistCrossoverTooltip } from './ArtistCrossoverTooltip';

export const ArtistCrossoverIcon = () => {
  return (
    <ArtistCrossoverTooltip>
      <span
        data-testid="artist-cross-over-icon"
        className="rounded-xs px-sm py-xs text-center text-body-xs font-semibold leading-tight bg-tertiary-default text-strong-on-light"
      >
        C
      </span>
    </ArtistCrossoverTooltip>
  );
};

ArtistCrossoverIcon.displayName = 'ArtistCrossoverIcon';
